<script>
export default {
  name: 'MeasureListItem',
  props: {
    measureItem: {
      type: Object,
      required: false,
      default: () => {},
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
    showMeasureDialog: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      localShowMeasureDialog: this.showMeasureDialog,
    };
  },
  computed: {
  },
  methods: {
  },
};
</script>

<template>
  <tr>
    <td>{{ measureItem.id }}</td>
    <td>{{ measureItem.name }}</td>
    <td>{{ measureItem.user ? measureItem.user.username : null }}</td>
    <td>{{ measureItem.isFinished ? 'ja' : 'nein' }}</td>
    <td>
      <v-btn icon slot="activator" @click="localShowMeasureDialog = true">
        <v-icon>add</v-icon>
      </v-btn>
    </td>
  </tr>
</template>
